
export const MACHINE_TYPE_OPTIONS = [
    { value: "1", label: "Auto" },
    { value: "2", label: "Manual" },
];

export const User_Role_Options = [
    { label: "Super Admin", id: 1 },
    { label: "Tenant Admin", id: 2 },
    { label: "Site Admin", id: 3 },
    { label: "Site User", id: 4 },
    { label: "Portal User", id: 4 },
    { label: "Portal Guest User", id: 6 },
    { label: "Mobile User", id: 7 },
    { label: "Mobile Guest User", id: 8 },
    { label: "Internal Inspector", id: 11 },
];